import Cookies from 'universal-cookie';

export const TOKEN_KEY_APP = "tenantBlocob3";
export const TOKEN_KEY = `${TOKEN_KEY_APP}.token`;

export const getTenantToken = () => {
    const cookies = new Cookies(document.cookie);
    return cookies.get(TOKEN_KEY);
}

export const setTenantToken = token => {
    const cookies = new Cookies();
    cookies.set(TOKEN_KEY, token, {
      path: '/',
      maxAge: 60 * 60 * 4 // 4 hours
    });
}

export const removeTenantToken = () => {
  const cookies = new Cookies(document.cookie);
  cookies.remove(TOKEN_KEY, { path: '/' });
}
